import { Carousel } from 'antd'
import React from 'react'
import { BASE_URL } from '../constants/Url'
import { useTranslation } from 'react-i18next';
import ScarfSreymoeun from '../components/ScarfSreymoeun';
import Events from '../components/Events';
import SchoolCommunity from '../components/SchoolCommunity';
import TabsHome from '../components/TabsHome';
import TabsManShirt from '../components/TabsManShirt';

export default function HomePage() {
  const { t } = useTranslation();

  return (
    <div className='w-full'>
      <Carousel className='w-full esi-carousel-banner' draggable dots pauseOnDotsHover pauseOnHover autoplay>
        <img className='esi-banner' src={BASE_URL + "about-us/Banner.png"} alt='Carousel-Image-1.png' />
        <img className='esi-banner' src={BASE_URL + "about-us/Banner1.png"} alt='Carousel-Image-2.png' />
        <img className='esi-banner' src={BASE_URL + "about-us/Banner2.png"} alt='Carousel-Image-3.png' />
      </Carousel>
      <div className='esi-white-space'></div>
      <div className='esi-std-container'>
        <div className='md:grid grid-cols-5 gap-3 flex flex-col-reverse'>
          <div className='max-w-[640px] sm:pb-3 col-span-3 flex flex-col gap-3'>
            <div className='esi-content-title'>
              {t("Sreymoeun Soeung Khmer")}
              <div className='esi-secondary-line'></div>
            </div>
          </div>
        </div>
        <TabsHome />
        <div className='esi-white-space'></div>
      </div>
      <ScarfSreymoeun />
      <Events />
      <div className='esi-white-space'></div>
      {/* <div className='esi-std-container'>
        <div className='md:grid grid-cols-5 gap-3 flex flex-col-reverse'>
          <div className='max-w-[640px] sm:pb-3 col-span-3 flex flex-col gap-3'>
            <div className='esi-content-title'>
              {t("Man's​ & Woman's Shirt Sreymoeun")}
              <div className='esi-secondary-line'></div>
            </div>
          </div>
        </div>
        <TabsManShirt />
        <div className='esi-white-space'></div>
      </div> */}
      <SchoolCommunity />
      {/* <Gallery /> */}
    </div>
  )
}
